import React from 'react';
import { Box, Grid, Typography, Fade } from '@mui/material';

const Banner: React.FC = () => {
    return (
        <Fade in={true} timeout={2800}>
            <Box
                position="relative"
                p={{ xs: 4, md: 12 }}
                mx="auto"
                maxWidth={{ xs: '100%', md: 800, lg: 1200, xl: 1400 }}
                height="auto"
                overflow="hidden"
                display="flex"
                alignItems="center"
                sx={{ color: '#ffffff' }}
            >
                <Grid container spacing={{ xs: 2, md: 0 }} alignItems="center" justifyContent="center">
                    <Grid
                        item
                        xs={12}
                        md={7}
                        display="flex"
                        flexDirection="column"
                        alignItems={{ xs: 'center', md: 'flex-start' }}
                        textAlign={{ xs: 'center', md: 'left' }}
                    >
                        <Typography
                            variant="h3"
                            component="h1"
                            sx={{
                                fontWeight: 600,
                                mb: 2,
                                background: 'linear-gradient(90deg, #aa3fff, #4376ff)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                display: 'inline-block',
                            }}
                        >
                            Predict Investment Trends
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: { xs: '18px', md: '20px' }, // Uppdaterad storlek
                                color: '#ffffff',
                                maxWidth: 600,
                                lineHeight: 1.7,
                            }}
                        >
                            Know things before others and turn SME markets<br />
                            into momentum-driven opportunities
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={5} display="flex" justifyContent="center">
                        <Box
                            sx={{
                                overflow: 'hidden',
                                width: { xs: '80%', md: '100%' },
                                maxWidth: { xs: 300, md: 420 },
                                height: 'auto',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src="/images/gen_ai.png"
                                alt="GenAI Signal mobile app interface"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    opacity: 0.95,
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Fade>
    );
};

export default Banner;